// removed by extract-text-webpack-plugin
module.exports = {"cloudRight":"_2GYu4","cloudLeft":"_2lrtf","flyin_left":"_3mQOH"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/SubjectHandler/SubjectHandler.scss
// module id = 896
// module chunks = 9